module.exports = __webpack_public_path__ + "assets/44669940c1b55856416703f5d2940acb.mp3";